import { Chip, IconButton, Tooltip } from "@mui/material";
import { Stack } from "@mui/system";
import React, { useRef, useState } from "react";
import Iconify from "src/components/iconify";

const AudioPlayer = ({ url }) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [hasStartedPlaying, setHasStartedPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  const handlePlay = async () => {
    try {
      await audioRef.current.play();
      setIsPlaying(true);
      setHasStartedPlaying(true);
    } catch (error) {
      console.error("Error playing audio:", error);
    }
  };

  const handlePause = () => {
    audioRef.current.pause();
    setIsPlaying(false);
  };

  const handleStop = () => {
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
    setIsPlaying(false);
    setHasStartedPlaying(false);
  };

  const handleTimeUpdate = () => {
    setCurrentTime(audioRef.current.currentTime);
  };

  const handleLoadedMetadata = () => {
    setDuration(audioRef.current.duration);
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };
  return (
    <Stack direction="row" alignItems="center" spacing={0}>
      <audio
        ref={audioRef}
        src={url}
        onEnded={() => {
          setIsPlaying(false);
          setHasStartedPlaying(false);
        }}
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={handleLoadedMetadata}
      />
      {!isPlaying ? (
        <Tooltip title="Tap to hear this message out loud.">
          <IconButton onClick={handlePlay}>
            <Iconify icon="icon-park-outline:voice-one" />
          </IconButton>
        </Tooltip>
      ) : (
        <IconButton onClick={handlePause}>
          <Iconify icon="icon-park-solid:pause-one" />
        </IconButton>
      )}
      {hasStartedPlaying && (
        <IconButton onClick={handleStop}>
          <Iconify icon="gravity-ui:stop-fill" />
        </IconButton>
      )}{" "}
      {hasStartedPlaying && (
        <Chip label={`${formatTime(currentTime)} / ${formatTime(duration)}`} />
      )}
    </Stack>
  );
};

export default AudioPlayer;
